$(document).ready(function() {
    'use strict';
    $('.gridSlideshow').slick({
        //config
    });
});
